<template>
  <div class="hello" >
     <div class="col-md-6">
         <div class="box_style_2" id="main_menu">
            <h2 class="inner">
            <span style="color: #fff; text-shadow: 0.5px 1px 0px #000; letter-spacing:0.5px">{{cat_name}}</span></h2>
            <h3 class="nomargin_top"></h3>
            <!-- <pizzaSize v-if="showPizzaSize"/> -->
            <div class="strip_list" v-for="(menu) in getMenu" :key="menu.menu_code" :id="menu.cat_id+'_'+menu.cat_code">
              <div id="menuItem">
              <div class="row">
                <div class="col-md-9 col-sm-9">
                    <div class="desc">
                      <div class="thumb_strip">
                          <a href="#"><img :src="menu.image" :alt="menu.menu_name" style="width:65px"></a>
                      </div>
                      <h3 style="font-size:14px;"> {{menu.cat_code}}) {{menu.name}}</h3>
                      <div class="ingredients">
                          <span class="opening" v-if="menu.cat_id === 1 || menu.cat_id === 2">{{ (menu.default_toppings != null) ? 'Ingredients:': '' }} </span>
                          <span class="opening" v-else>{{ (menu.default_toppings != null) ? 'Varieties:': '' }} </span>
                           {{menu.default_toppings}}
                          
                      </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-3">
                    <div class="go_to">
                      <div>
                        <a href="javascript:void(0)" @click.prevent="openList(menu.id,menu.slug, menu.cat_id)"  :id="'open_'+menu.slug+'-'+menu.id" class="btn_1 collapsed_open" aria-expanded="false">Select</a>
                        <a href="javascript:void(0)" @click.prevent="closeList(menu.id,menu.slug)" :id="'close_'+menu.slug+'-'+menu.id" class="btn_1 collapsed_close" style="display: none">Select</a>
                      </div>
                    </div>
                </div>
              </div>
              </div>
              <div :id="menu.slug+'-'+menu.id" style="display:none; margin-top:15px" class="topping_class">
                <div class="panel-body nopadding">
                    <div class="col-lg-12" style="margin-bottom: 10px; color: #fa4936; font-weight: 600; padding-left:0">
                        <small>Choose Size</small>
                    </div>
                    <div class="size-selection">
                    <div class="col-lg-12" v-for="size in getPizzaSizes" :key="size.id" :id="size.id" style="padding:0">
                    <div class="msh-item">
                    <div class="row">
                    <div class="col-md-6 col-xs-6 col-sm-6">
                        <div class="custom-control custom-radio">
                            <input type="hidden" :id="menu.slug+'_sizeid_'+size.id" :value="size.id">
                            <input type="radio" class="custom-control-input" 
                            :value="size.name" :id="menu.slug+'_'+size.id" :name="menu.slug"
                            @change="changePizzaSize(menu.slug, size.id)"
                            >
                            <label class="custom-control-label" :for="menu.slug+'_'+size.id">{{ size.name }}</label>
                        </div> 
                    </div>
                    <div class="col-md-2 col-xs-2 col-sm-2" style="">
                        <div class="form-group margin-bottom-0">
                          <!-- v-show="(menu.cat_id != 7 && menu.cat_id != 12)&& menu.id != 72"    -->
                          <select class="form-control pizzano"
                              
                              style="width:50px; margin-left: -10px;"
                              name="" 
                              :id="menu.slug+'_'+size.id+'_size'" 
                              @change="selectPizzaQty(menu.slug,size.id)">
                              <option v-for="(nopizza, index) of getNoPizza" :key="menu.slug+'_'+index+'_'+nopizza.id" :value="nopizza.value"> {{ nopizza.value}} </option>
                          </select>
                          </div>
                          <input type="hidden" :id="menu.slug+'_'+size.id+'_dprice'" :value="size.price">  
                      </div>

                      <div class="col-md-3 col-xs-2 col-sm-2 text-right"> 
                        <div class="label label-danger price" :id="menu.slug+'_'+size.id+'_price'"> {{ size.price }}</div></div>
                    </div>
                    </div>
                    </div>
                </div>
                </div>

                <hr style="margin:5px 0px">
                <div class="panel-body nopadding">
                  <small style="color:#fa4936; font-weight:600" v-show="extraToppings.length > 0 || defaultToppings.length > 0">
                    {{ (menu.cat_id === 1 || menu.cat_id === 2 ) ? 'Edit Pizza' : 'Edit Varities' }}
                  </small>
                  <small style="color:#fa4936; font-weight:600;" class="pull-right">Total Cost: AU$ <b :id="menu.slug+'_pizza_price'">{{total_cost}}</b></small>
                  <small style="color:#fa4936; font-weight:600;display:none" class="pull-right">Varity Cost: AU$ <b :id="menu.slug+'_varity_price'">{{total_cost}}</b></small>
                </div>
                <div class="row ms-fix-height">
                  <div class="desk-p-r" :class="(extraToppings.length == 0) ? 'col-lg-12': 'col-lg-6'" v-show="defaultToppings.length > 0">
                    <div class="msh-item padding-bottom-10px padding-left-5 padding-right-5 padding-top-5">
                      <table class="table margin-bottom-0">
                        <h5 align="left" class="font-weight-600" style="padding-left: 8px;">
                          {{(menu.cat_id == 1 || menu.cat_id == 2 ) ? 'Current Toppings':'Current Varieties'}}
                          <span class="pull-right" style="display:none">AU$ <span :id="menu.slug+'_etttoal'">0.00</span></span>
                          <span class="pull-right" style="display:none">VT AU$ <span :id="menu.slug+'_vtttoal'">0.00</span></span>
                        </h5>
                        
                        <tbody :id="menu.slug+'_defaultToppiings'" >
                          <!-- <tr v-for="dtopp in defaultToppings" :key="'defaultToppings_'+dtopp.def_ing_id"
                                :id="menu.slug+'-default_'+dtopp.def_ing_id"
                                v-show="dtopp.def_ing_name"
                            >
                            <td>
                                <a href="javascript:void(0)" class="remove_item" @click.prevent="removeCurrentToppings(menu.slug,dtopp.def_ing_id)"><i class="icon_minus_alt2"></i></a> 
                            </td>
                            <td style="width:140px" :id="menu.slug+'_ct_topping_name_'+dtopp.def_ing_id">
                               {{dtopp.def_ing_name}}
                            </td>
                            <td>
                                <strong class="pull-right">$ <span :id="menu.slug+'_ct_price_'+dtopp.def_ing_id">
                                  {{dtopp.def_topp_price}}</span></strong>
                            </td>
                          </tr> -->
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-lg-6 desk-p-r" v-show="extraToppings.length > 0">
                    <div class="msh-item padding-bottom-10px padding-left-5 padding-right-5 padding-top-5">
                      <table class="table margin-bottom-0">
                        <h5 align="left" v-if="filterButton" class="font-weight-600" style="padding-left: 8px;">Extra Toppings 
                          <i class="fa fa-filter pull-right" @click.prevent="filterClicked" style="position: absolute; 
                          top:14px; right:14px;font-size: 16px"></i>
                        </h5>
                        <div class="row" v-if="filterDiv" style="height: 35px;">
                          <div class="col-lg-10">
                            <input type="text" name="" id="filter" v-model="filterText" @keyup="filterToppings(menu.slug)" class="form-control" style="width:100%; text-align:left; padding-left: 10px; color: green">
                          </div>
                          <div class="col-lg-2">
                             <i class="fa fa-times-circle close-filter" @click.prevent="closeFilter(menu.slug)" style="position: absolute; 
                          top:5px; right:14px;font-size: 20px"></i>
                          </div>
                        </div>
                        <tbody :id="menu.slug+'_extraToppiings'">
                          <!-- <tr v-for="etopp in extraToppings" :key="etopp.def_ing_id" :id="menu.slug+'-current_'+etopp.def_ing_id"
                          v-show="etopp.def_ing_name">
                              <td>
                                <a href="javascript:void(0)" class="add_item" :id="menu.slug+'_addBtn_'+etopp.def_ing_id" @click.prevent="addCurrentToppings(menu.slug,etopp.def_ing_id)"><i class="icon_plus_alt2"></i></a> 
                              </td>
                              <td style="width:140px" :id="menu.slug+'_et_topping_name_'+etopp.def_ing_id">
                                {{etopp.def_ing_name}}
                              </td>
                              <td>
                                  <strong class="pull-right">$ <span :id="menu.slug+'_et_price_'+etopp.def_ing_id">{{ etopp.def_topp_price}}</span> </strong>
                              </td>
                            </tr> -->
                          <tr v-if="extraToppings.length === 0">
                            <p style="font-size:12px; margin-left: 15px">
                              No Extra Toppings
                            </p> </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <hr style="margin:5px 0px">
                <div class="panel-body nopadding">
                    <small style="color:#fa4936; font-weight:600">COMMENTS (Special Requirements)</small>
                </div>
                <div class="row ms-fix-height">
                  <div class="col-lg-12" style="margin-right:0">
                    <textarea :id="menu.slug+'_specialComments'" cols="5" class="form-control" rows="2" style="resize: none" placeholder="If Any Special requirements, add here"></textarea>
                    <button class="btn_1 pull-right" style="margin-top:5px" @click.prevent="addOrder(menu.slug,menu.id)">Add Order</button>
                  </div> 
                  
                </div>
            </div>

            </div>

            </div>  
     </div>
  </div>  
</template>

<script>
import pizzaSize from '@/components/pizzaSize'

import { mapGetters, mapActions } from 'vuex'
import { parse } from 'path';
import * as render from '../utils/render'

export default {
  name: 'MenuLists',
  data() {
    return {
      filterButton: true,
      filterDiv: false,
      filterText: '',
      noOfPizzaSize: '',
      shouldStick: false,
      special_comments: '',
      total_cost: '0.00',
      fixed: false
    }
  },
  components: {
    pizzaSize
  },
  created() {
    this.$store.watch( getters => getters.defaultToppings)
    this.$store.watch(getters => getters.extraToppings)
    this.$store.watch( getters => getters.isLoggedIn)
    this.$store.dispatch("getMenu", this.$route.params.id);
    this.$store.dispatch("getDefaultToppings", this.$route.params.id);
    this.$store.dispatch("getExtraToppings", this.$route.params.id);
  },
  computed: {
    ...mapGetters(['getMenu','short_name','cat_name','getPizzaSizes','extraToppings','defaultToppings','getNoPizza','showPizzaSize','selectedItems','cat_id','isLoggedIn'])
  },
  methods: {
    selectRibRange(s,i){
       if($("input[name="+s+"]:checked").length == 0){
        this.$fire({
          title: "Waring",
          text: "Please select qty",
          type: "warning",
          timer: 3000
        }).then(r => {
          $("#"+s+'_varieties_name_'+i).prop('checked', false)
        });
      }else{
          // console.log("select ribs " + s + ' - ' + i)
          var checked_id = $("input[name="+s+"]:checked").prop('id');
          let verieties_name = $("#"+s+'_varieties_name_'+i).val();
          let size_id = $("#"+s+'_varieties_id_'+i).val();
          
          let user_key = sessionStorage.getItem('user_key');
          let addDefaultFlavourItems = {"user_key":user_key,"menuName": s,"etopp_id": size_id,"pizza_total": 0.00,"etopp_name": verieties_name,"etopp_qty": 1 , "etopp_price" : 0.00}
          this.$store.dispatch('addDefaultFlavour', addDefaultFlavourItems)
      }
    },
    selectVarieties(s,i){
       // alert("varities");
      if($("input[name="+s+"]:checked").length === 0){
        this.$fire({
          title: "Waring",
          text: "Please select qty",
          type: "warning",
          timer: 3000
        }).then(r => {
          $("#"+s+'_varieties_name_'+i).prop('checked', false)
          // $("#"+s+'_vprice_'+i).val('0.00')
        });
      }else{
        if($("input[id="+s+'_varieties_name_'+i+"]:checked").length === 0){
            var checked_id = $("input[name="+s+"]:checked").prop('id');
            var default_price = $("#"+checked_id+'_dprice').val();
            //alert(default_price);
            var varity_cost = $("#"+s+'_vprice_'+i).val();
            let pprice = $("#"+s+'_pizza_price').text()
            //+parseFloat(default_price)
            let price_updated = '0.00';
            let main_price_updated = (parseFloat(pprice)-parseFloat(varity_cost));
            $("#"+s+'_pizza_price').text(main_price_updated);

            $("#"+s+'_varieties_qty_'+i).prop('selectedIndex',0);
            $("#"+s+'_vprice_'+i).val('0.00');
            $("#"+s+'_vtttoal').text('0.00');
            
            let verieties_name = $("#"+s+'_varieties_name_'+i).val();
            let size_id = $("#"+s+'_varieties_id_'+i).val();
            let verieties_qty = $("#"+s+'_varieties_qty_'+i).val();

            let user_key = sessionStorage.getItem('user_key');
            let addedToppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": size_id,"pizza_total": price_updated,"etopp_name": verieties_name,"etopp_qty": verieties_qty , "etopp_price" : 0.00}
            this.$store.dispatch('deleteVarieties', addedToppingsItem).then((response) =>{
                if(parseFloat(main_price_updated) === 0.00){
                  price_updated = default_price;
                }else{
                  price_updated = main_price_updated;
                }
                // this.$fire({
                //   html: response,
                //   type: "success",
                //   timer: 3000
                // })
            })

        }
      }
    },
    selectVarityQty(s,i){
        // alert(s + i);
      if($("input[name="+s+"]:checked").length > 0){
        if($("input[id="+s+'_varieties_name_'+i+"]:checked").length > 0){
            let verieties_name = $("#"+s+'_varieties_name_'+i).val();
            let size_id = $("#"+s+'_varieties_id_'+i).val();
            let verieties_size = $("#"+s+'_'+i).val();
            let user_key = sessionStorage.getItem('user_key')
            let default_price = $("#"+s+'_varity_price').text();
            let verieties_qty = $("#"+s+'_varieties_qty_'+i).val();
            let total_cost = verieties_qty*parseFloat(default_price);
            let vprice = $("#"+s+"_vprice_"+i).val();
            let varity_total = $("#"+s+'_vtttoal').text();
            let final_varity_total = (parseFloat(varity_total)-parseFloat(vprice)) + parseFloat(total_cost);
            $("#"+s+'_vprice_'+i).val(total_cost.toFixed(2));
            $("#"+s+'_vtttoal').text(final_varity_total);
            
            let final_cost_varity_total = $("#"+s+'_pizza_price').text(final_varity_total.toFixed(2));
            
            let addedToppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": size_id,"pizza_total": final_varity_total,"etopp_name": verieties_name,"etopp_qty": verieties_qty , "etopp_price" : 0.00}
            this.$store.dispatch('addDefaultToppings', addedToppingsItem)
            
        }else{
          this.$fire({
            title: "Waring",
            text: "Please select Varities first",
            type: "warning",
            timer: 3000
          }).then(r => {
            $("#"+s+'_varieties_name_'+i).prop('checked', false)
            $("#"+s+'_varieties_qty_'+i).prop('selectedIndex',0);
            // $("#"+s+'_vprice_'+i).val('0.00');
          });
        }
      }else{
        this.$fire({
          title: "Waring",
          text: "Please select qty",
          type: "warning",
          timer: 3000
        }).then(r => {
          $("#"+s+'_varieties_name_'+i).prop('checked', false)
          $("#"+s+'_varieties_qty_'+i).prop('selectedIndex',0);
          // $("#"+s+'_vprice_'+i).val('0.00');
        });
      }
    },
    changePizzaSize(s,i){
          // alert(s+i)
          let pizza_size_list = this.getPizzaSizes;
          let currentprice;
          $.each(pizza_size_list, (index, value) => {
              if(value.id != i){

                  if(this.defaultToppings){
                      $("#"+s+'_varieties_name_'+this.defaultToppings[0].def_ing_id).prop("checked", true);
                      $("#"+s+'_varieties_qty_'+this.defaultToppings[0].def_ing_id).prop("selectedIndex", 1);
                  }
                  $(".vprice").val('0.00');
                  $("#"+s+'_vtttoal').text('0.00');
                  $("#"+s+'_'+value.id).attr("checked",false);
                  $("#"+s+'_'+value.id+'_size').prop('selectedIndex',0)
                  $("#"+s+'_'+value.id+'_price').text($("#"+s+'_'+value.id+'_dprice').val());
              }else{
                  $("#"+s+'_'+i).attr("checked",true);
                  let sizeDiv = s+'_'+i+'_size';
                  let noOfPizza = $("#"+sizeDiv).val();
                  let menuPizzaSize = $("#"+s+'_'+i).val()
                  let priceDiv = s+'_'+i+'_price';
                  let price = $("#"+priceDiv).text();
                  let defaultprieDiv = s+'_'+i+'_dprice';
                  let defaultPrice = $("#"+defaultprieDiv).val();
                  $("#"+s+'_pizza_price').text(parseFloat(defaultPrice));
                  let total_price = noOfPizza*defaultPrice;
                  let pizzaTotal = s+'_pizza_price';
                  let size_id = $("#"+s+'_sizeid_'+i).val();
                  let etfinalprice = $("#"+s+'_etttoal').text();

                  $("#"+s+'_varity_price').text(parseFloat(defaultPrice))
                  // alert(defaultPrice);
                  $("#"+pizzaTotal).text(defaultPrice)
                  let CalculatedPrice = parseFloat(total_price)+parseFloat(etfinalprice)
                  $("#"+pizzaTotal).text(CalculatedPrice.toFixed(2))
                  $("."+s+'_varieties_name').prop('checked', false);
                  $("."+s+'_varieties_qty').prop('selectedIndex',0);
                  $("#"+s+'_vtttoal').text('0.00');
                  $(".vprice").val('0.00');
                  if(this.defaultToppings) {
                      $("#" + s + '_varieties_name_' + this.defaultToppings[0].def_ing_id).prop("checked", true);
                      $("#"+s+'_varieties_qty_'+this.defaultToppings[0].def_ing_id).prop("selectedIndex", 1);
                  }
                  let user_key = sessionStorage.getItem('user_key');
                  let menu = {"user_key":user_key,"menuName":s, "id": size_id ,"size": menuPizzaSize, "qty": noOfPizza,"menu_price": defaultPrice ,"price": total_price, "comments": ''};
                  this.$store.dispatch('addMenus', menu)
              }
          })

    },
    selectPizzaQty(s,i){
          let pizza_size_list = this.getPizzaSizes;
          $.each(pizza_size_list, (index, value) => {
            if(value.id != i){
              $("#"+s+'_'+value.id+'_size').prop('selectedIndex',0)
              $("#"+s+'_'+value.id+'_price').text($("#"+s+'_'+value.id+'_dprice').val());
            }else{
              // $(".pizzano").prop('selectedIndex',0);
              let sizeDiv = s+'_'+i+'_size';
              let noOfPizza = $("#"+sizeDiv).val();
              let menuPizzaSize = $("#"+s+'_'+i).val();
              let priceDiv = s+'_'+i+'_price';
              let price = $("#"+priceDiv).text();
              // console.log("price " + price)
              let defaultprieDiv = s+'_'+i+'_dprice';
              let defaultPrice = $("#"+defaultprieDiv).val();
              // console.log("default price  " + defaultPrice)
              let total_price = noOfPizza*defaultPrice;
              // console.log("total price  " + total_price)
              let pizzaTotal = s+'_pizza_price';
              let size_id = $("#"+s+'_sizeid_'+i).val();
              let etfinalprice = $("#"+s+'_etttoal').text();
              let CalculatedPrice = total_price+parseFloat(etfinalprice)
              // console.log("cal price " + CalculatedPrice)
              $("#"+pizzaTotal).text(CalculatedPrice.toFixed(2))
              let user_key = sessionStorage.getItem('user_key');
              let menu = {"user_key":user_key,"menuName":s, "id": size_id ,"size": menuPizzaSize, "qty": noOfPizza,"menu_price": defaultPrice ,"price": total_price, "comments": ''};
              this.$store.dispatch('addMenus', menu)
              
              $("#"+priceDiv).text(total_price.toFixed(2));
              $("#"+s+'_'+i).prop("checked",true);  
            }
          })
           
        
    },
    addOrder(s,i){
      if($("input[name="+s+"]:checked").length > 0){
        let isLoggedIn = this.isLoggedIn  
        if(isLoggedIn === false){
          $("#register").modal('show');
          this.$store.dispatch('openPopup', 'login')
        }else{
          let user_key = sessionStorage.getItem('user_key')
          let comment = $("#"+s+'_specialComments').val();
          let pizza_price = $("#"+s+'_pizza_price').text();
          let cat_id = this.cat_id;
          let payload = {"user_key":user_key, "menu_slug" : s , "category_id": cat_id, "menu_id": i,"comments" : comment, "pizza_price": pizza_price}
          // console.log('payload ' + payload)
          this.$store.dispatch('addOrder', payload)
              .then((orders,order_total) => {
                $("input[type=radio]").prop("checked", false);
                $("#"+s+'_'+i+'_size').prop('selectedIndex',0);
                let defaultprieDiv = s+'_'+i+'_dprice';
                let defaultPrice = $("#"+defaultprieDiv).val();
                let priceDiv = s+'_'+i+'_price';
                $("#"+priceDiv).text(defaultPrice);

                let btn_open_id = '#open_'+s+'-'+i;
                let btn_close_id = '#close_'+s+'-'+i;
                $(".topping_class").css({'display':'none'});
                $(btn_open_id).css({'display':'inline-block'});
                $(btn_close_id).css({'display':'none'});

                let pizzaTotal = s+'_pizza_price';
                $("#"+pizzaTotal).text('0.00');

                let defaultToppings = this.$store.getters.defaultToppings;
                render.defaultToppings(s,defaultToppings);
                
                let extraToppings = this.$store.getters.extraToppings;
                render.extraToppings(s,extraToppings);
                render.cartItem(orders);
                if(order_total){
                  render.subTotal(order_total.sub_total)
                  render.deliveryAmount(order_total.delivery_amount)
                  render.totalAmount(order_total.total_amount)
                  
                }
                
              });
          }
      }else{
          this.$fire({
              html: "<b>please select size or quantity</b>",
              title: 'Error !!',
              type: "error",
              timer: 3000
          })
          return false;
      }

    },
    filterToppings(s){
      let search = this.filterText.toLowerCase();
      $("#"+s+'_extraToppiings tr').filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(search) > -1);
      });
    },
    filterClicked(){
      this.filterButton = false,
      this.filterDiv = true
    },
    closeFilter(s){
      this.filterButton = true
      this.filterDiv = false
      this.filterText = ''
      // this.filterToppings(s);
    },
    openList(i,s,cat_id) {

      this.$store.dispatch("getMenuSizes", {
        'cat_id' : cat_id,
        'menu_id': i
      });
      
      
      this.$store.dispatch("getDefaultToppings", i).then( defaultToppings  => {
          render.defaultToppings(s,defaultToppings);
          defaultToppings.forEach( (dtopp) => {
          let button = "#"+s+'_removeCurrentToppingBtn_'+dtopp.def_ing_id;
          $(document).on('click',button, () => {
            this.removeCurrentToppings(s,dtopp.def_ing_id);
          });
        });
        
      });
      this.$store.dispatch("getExtraToppings", i).then(extraToppings => {
          render.extraToppings(s,extraToppings);
          extraToppings.forEach( (etopp) => {
          let button = "#"+s+'_addBtn_'+etopp.def_ing_id;
          $(document).on('click',button, () => {
            this.addCurrentToppings(s,etopp.def_ing_id);
          });
        });
      });      
      
      setTimeout( () => {
        let defaultToppings = this.$store.getters.defaultToppings;
        let payload = { "defaultToppings": defaultToppings, "menu_slug": s}
        this.$store.dispatch("setMenuItem",payload);
      },1000);

      setTimeout(() => {
        $("input[name=radio]").prop('checked', false);
        $(".topping_class").css({'display':'none'});
        $(".collapsed_open").css({'display':'inline-block'});
        $(".collapsed_close").css({'display':'none'});
        let id = '#'+s+'-'+i;
        let btn_open_id = '#open_'+s+'-'+i;
        let btn_close_id = '#close_'+s+'-'+i;
        $(id).css({'display':'block','height':'auto !important'});
        $(btn_open_id).css({'display':'none'});
        $(btn_close_id).css({'display':'inline-block'});
      },1000);

    },
    closeList(i,s){
      let id = '#'+s+'-'+i;
      let btn_open_id = '#open_'+s+'-'+i;
      let btn_close_id = '#close_'+s+'-'+i;
       $(id).css({'display':'none','height':'auto !important'});
      $(btn_open_id).css({'display':'inline-block'});
      $(btn_close_id).css({'display':'none'});
      
    },
    addCurrentToppings(s,i){
      
      if($("input[name="+s+"]:checked").length > 0){
        let ETQty = 1;
        let ETToppingName = $( "#"+s+"_et_topping_name_"+i).text()
        let ETPrice = $("#"+s+"_et_price_"+i ).text();
        if(ETPrice != ''){
          render.addToppings(s,i,ETToppingName,ETPrice)
          let pizzaTotal = s+'_pizza_price';
          let pizzaTotalPrice = $("#"+pizzaTotal).text();
          let FinalPrice = parseFloat(pizzaTotalPrice) + parseFloat(ETPrice)
          let ettotal = $("#"+s+'_etttoal').text();
          let etfinal = parseFloat(ettotal)+parseFloat(ETPrice);
          $("#"+s+'_etttoal').text(etfinal.toFixed(2));
          $("#"+pizzaTotal).text(FinalPrice.toFixed(2))
          // hidden field
          $("#"+s+'-current_'+i).remove();
          let TotalPrice = $("#"+pizzaTotal).text()
          // add toppings store update
          let user_key = sessionStorage.getItem('user_key');
          let toppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": i,"pizza_total": TotalPrice,"etopp_name": ETToppingName,"etopp_qty": ETQty , "etopp_price" : ETPrice }
          this.$store.dispatch('addToppings', toppingsItem)
        }
        $('#'+s+'_removeItem_'+i).click(() => {
          let removedToppingsPrice = $("#"+s+'_addedExtraToppingPrice_'+i).text()
          let UpdatedPrice = $("#"+s+'_etttoal').text()-removedToppingsPrice
          $("#"+s+'_etttoal').text(UpdatedPrice.toFixed(2))
          let UpdatedTotalPrice = $("#"+s+'_pizza_price').text()-removedToppingsPrice
          $("#"+s+'_pizza_price').text(UpdatedTotalPrice.toFixed(2))
          
          //current toppings 
          $("#"+s+'_addedExtraToppings_'+i).remove();
          if(removedToppingsPrice != ''){
            let removedToppingsName = ETToppingName
            render.removeToppings(s,i,removedToppingsName,removedToppingsPrice)
          }

          $("#"+s+'_addBtn_'+i).on('click', () => {
              this.addCurrentToppings(s,i);
          });
          // remove Toppings - store update
          setTimeout(() => {
            let TotalPrice = $("#"+s+'_pizza_price').text();
            let user_key = sessionStorage.getItem('user_key');
            let removeToppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": i,"pizza_total": TotalPrice}
            this.$store.dispatch('removeToppings', removeToppingsItem)
          },2000);
        });
      }else{
        this.$fire({
           html: "<b>please select size or quantity</b>",
          title: 'Error !!',
          type: "error",
          timer: 3000
         })
        return false;
      }
    },
    extraToppingsQty(s,i){
      let extraToppingQtyID = "#"+s+"_et_qty_"+i 
      let extraTopingPriceID = "#"+s+"_et_price_"+i 
      let ETQty = $(extraToppingQtyID).val()
      let extraToppingsPrice = (ETQty * 2.00)
      $(extraTopingPriceID).text(extraToppingsPrice.toFixed(2))
    },
    defaultToppingsQty(s,i){
      if($("input[name="+s+"]:checked").length > 0){
        let qty = $("#"+s+'_ct_qty_'+i).val();
        console.log("Quantity " + qty)
        $("#"+s+'_ct_price_'+i).text();
        let total_pizza_price = $("#"+s+'_pizza_price').text();
        if(qty == 1){
          var amount = 0.00;
          let minusPrice = 2.00;
          let finalPrice = parseFloat(total_pizza_price)-parseFloat(minusPrice);
          $("#"+s+'_pizza_price').text(finalPrice.toFixed(2));
          setTimeout(() => {
            let CTName = $("#"+s+'_ct_topping_name_'+i).text();
            let CTQty = $("#"+s+'_ct_qty_'+i).val();
            let CTPrice = $("#"+s+'_ct_price_'+i).text();
            let TotalPrice = $("#"+s+'_pizza_price').text();
            let user_key = sessionStorage.getItem('user_key');
            let addedToppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": i,"pizza_total": TotalPrice,"etopp_name": CTName,"etopp_qty": CTQty , "etopp_price" : CTPrice}
            this.$store.dispatch('removeDefaultToppings', addedToppingsItem)
          },2000);
        }else{
          var amount = 2.00;
          let finalPrice = parseFloat(total_pizza_price)+parseFloat(amount);
          $("#"+s+'_pizza_price').text(finalPrice.toFixed(2));
          setTimeout(() => {
            let CTName = $("#"+s+'_ct_topping_name_'+i).text();
            let CTQty = $("#"+s+'_ct_qty_'+i).val();
            let CTPrice = $("#"+s+'_ct_price_'+i).text();
            let TotalPrice = $("#"+s+'_pizza_price').text();
            let user_key = sessionStorage.getItem('user_key');
            let addedToppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": i,"pizza_total": TotalPrice,"etopp_name": CTName,"etopp_qty": CTQty , "etopp_price" : CTPrice}
            this.$store.dispatch('addDefaultToppings', addedToppingsItem)
          },2000);

        }
        $("#"+s+'_ct_price_'+i).text(amount.toFixed(2));
      }else{
        this.$fire({
           html: "<b>please select size or quantity</b>",
          title: 'Error !!',
          type: "error",
          timer: 3000
         })
        $('#'+s+'_ct_qty_'+i).prop('selectedIndex',0);
        return false;
      }
      
    },
    removeCurrentToppings(s,i){
       if($("input[name="+s+"]:checked").length > 0){
            $(".remove_item").prop("disabled", true);
            $(".remove_item").css({'color':'#000000'});
            $('#'+s+'_ct_qty_'+i).prop('selectedIndex',0);
            $('#'+s+'_ct_price_'+i).text('0.00');
            let total_pizza_price = $("#"+s+'_pizza_price').text();
            if($('#'+s+'_ct_qty_'+i).val() === 2){
              var minusPrice = 2.00;
            }else{
              var minusPrice = 0.00;
            }
            
            let finalPrice = parseFloat(total_pizza_price)-parseFloat(minusPrice);
            $("#"+s+'_pizza_price').text(finalPrice.toFixed(2));
            
            let CTName = $("#"+s+'_ct_topping_name_'+i).text();
            let CTQty = $("#"+s+'_ct_qty_'+i).val();
            let CTPrice = $("#"+s+'_ct_price_'+i).text();
            let TotalPrice = $("#"+s+'_pizza_price').text();
            let user_key = sessionStorage.getItem('user_key');
            let addedToppingsItem = {"user_key":user_key,"menuName": s,"etopp_id": i,"pizza_total": TotalPrice,"etopp_name": CTName,"etopp_qty": CTQty , "etopp_price" : CTPrice}
            // $("#"+s+'-default_'+i).remove();

            this.$store.dispatch('removeDefaultToppings', addedToppingsItem).then((response) =>{
              $("#"+s+'-default_'+i).remove();
              $(".remove_item").prop("disabled", false);
              $(".remove_item").css({'color':'#e76060'});
            });
       }else{
         this.$fire({
           html: "<b>please select size or quantity</b>",
          title: 'Error !!',
          type: "error",
          timer: 3000
         })
        $('#'+s+'_ct_qty_'+i).prop('selectedIndex',0);
      }
    },
  },
  mounted() {
    
  },
}
</script>
<style scoped>
.extraTopping{
    border: 1px solid #ceccccf7;border-radius: 4px;margin: 5px 0px 0px 0px;padding-bottom: 5px;padding-right: 15px;margin: 3px 5px 0;width: 96%;position: relative;box-shadow: 1px 1px 2px 2px #d2d1d1ad;
}
.custom-control-label{
  font-size: 14px;
  font-weight: 700;
}
.custom-checkbox input[type=checkbox] {
	opacity: 0;
	position: absolute;
	margin: 5px 0 0 3px;
	z-index: 9
}

.custom-checkbox label:before {
	width: 1.2em;
	height: 1.2em;
	content: '';
	margin-right: 10px;
	display: inline-block;
	vertical-align: text-top;
	background: #fff;
	border: 1px solid #3e3e3e;
	border-radius: 2px;
	box-sizing: border-box;
	z-index: 2
}

.custom-checkbox input[type=checkbox]:checked+label:after {
	content: '';
	position: absolute;
	left: 6px;
	top: 2px;
	width: 6px;
	height: 11px;
	border: solid #3e3e3e;
	border-width: 0 3px 3px 0;
	transform: inherit;
	z-index: 3;
	transform: rotateZ(45deg)
}


.custom-checkbox input[type=checkbox]:checked+label:before {
	border-color: #0098D7;
	background: #0098D7
}

.custom-checkbox input[type=checkbox]:checked+label:after {
	border-color: #fff
}

.custom-checkbox input[type=checkbox]:disabled+label:before {
	color: #3e3e3e;
	cursor: auto;
	box-shadow: none;
	background: #ddd
}

.custom-radio [type=radio]:checked,
.custom-radio [type=radio]:not(:checked) {
	position: absolute;
	left: -9999px
}

.custom-radio [type=radio]:checked+label,
.custom-radio [type=radio]:not(:checked)+label {
	position: relative;
	padding-left: 28px;
	cursor: pointer;
	line-height: 20px;
	display: inline-block;
	width: auto;
	height: 9px
}

.custom-radio [type=radio]:checked+label:before,
.custom-radio [type=radio]:not(:checked)+label:before {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	width: 18px;
	height: 18px;
	border: 1px solid #c3cbd5;
	border-radius: 100%;
	background: #fff
}

.custom-radio [type=radio]:checked+label:after,
.custom-radio [type=radio]:not(:checked)+label:after {
	content: '';
	width: 10px;
	height: 10px;
	background: #fa4936;
	position: absolute;
	top: 4px;
	left: 4px;
	border-radius: 100%;
	-webkit-transition: all .2s ease;
	transition: all .2s ease
}
.custom-radio [type=radio]:not(:checked)+label:after {
	opacity: 0;
	-webkit-transform: scale(0);
	transform: scale(0)
}

.custom-radio [type=radio]:checked+label:after {
	opacity: 1;
	-webkit-transform: scale(1);
	transform: scale(1)
}
.fa-filter:hover{
   color: red;
   cursor: pointer;
}
.close-filter:hover{
  cursor: pointer;
}
.price{
  padding: 10px 15px;
  font-size: 1.1em;
  display: inline-block;
  margin-top:-6px
}
.msh-item label {
    font-size: 14px;
    margin-left: 5px;
}
/* custom checkbox */
.container-checkbox {
  display: block;
  position: relative;
  padding-left:25px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 700;
}

/* Hide the browser's default checkbox */
.container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: rgba(97, 179, 83, 0.733);
}

/* On mouse-over, add a grey background color */
.container-checkbox:hover input ~ .checkmark {
  background-color: rgba(97, 179, 83, 0.733);
}

/* When the checkbox is checked, add a blue background */
.container-checkbox input:checked ~ .checkmark {
  background-color: #000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>